import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useProtectedClient, useCurrentUser, useGroupSearch } from 'hooks';
import { isAdminUser } from 'helpers';
import { GroupCreate } from 'Links';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  image: {
    width: 150,
    height: 150,
  },
}));

const CreateGroup: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const client = useProtectedClient();

  const { department_id, department_title } = currentUser;
  const isAdmin = isAdminUser(currentUser);
  const canCreate = !isAdmin && !department_id && client.allow_group_creation;

  const variables = {
    required_department_id: department_id,
    size: 0,
    results_from: 0,
  };

  const { count } = useGroupSearch(variables, {
    enabled: canCreate,
  });

  if (canCreate || !count) {
    return null;
  }

  return (
    <Grid item xs>
      <Card className={classes.root}>
        <img src="/images/box-cards.svg" className={classes.image} />
        <CardContent>
          <Typography paragraph align="center" variant="subtitle2">
            {t('components:createGroupWidget', { title: department_title })}
          </Typography>
          <Button component={GroupCreate} variant="contained" color="primary">
            {t('groups:createGroup')}
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default CreateGroup;
